<template>
 <!--  -->
  <div class="page-container">
    <div class="d-flex">
      <div class="d-flex flex-row flex-1">
        <img src="../assets/form/1/img/1.png" alt="img">
        <div class="mlrs-title">
          <h5>MLRS 2019</h5>
          <div>Machine Learning Research School 2019</div>
          <div>DEPA, Bangkok, Thailand</div>
        </div>
      </div>
      <div class="payment-container">
        <h4>Payment Receipt</h4>
        <div class="mt-2">Ref: {{ receipt.id }}</div>
        <div>Date: <span>{{ receiptDate }}</span></div>
      </div>
    </div>
    <div class="d-flex mt-5">
      <div class="d-flex flex-column flex-1 text-left">
        <div class="sub-title">
          Customer Detail
        </div>
        <div class="mt-2">
          <b>{{ name }}</b>
        </div>
        <div>
          {{ company }}
        </div>
        <div class="pr-2">
          {{ address }}
        </div>
        <div>
          {{ tel }}
        </div>
      </div>
      <div class="d-flex flex-column flex-1 text-left">
        <div class="sub-title">
          Payment Recieved
        </div>
        <div>
          {{  payment.timestamp }}
        </div>
        <div class="sub-title mt-4">
          Payment Method
        </div>
        <div>
          PayPal Payment <br/>
          (Transaction ID: {{ payment.paypal.id }})
        </div>
      </div>
    </div>
    <div class="flex mt-5">
      <table style="width:100%">
        <tr height="50">
          <th>ID</th>
          <th>Registration Detail</th>
          <th>Amount</th>
        </tr>
        <tr height="100">
          <td>{{ payment.orderId }}</td>
          <td>
            <div><b>MLRS 2109 Registraion Fee</b></div>
            <div class="mt-2">{{ payment['First name'] }}&nbsp;{{  payment['Last name (family name)'] }}</div>
          </td>
          <td>{{  payment.Fee }}</td>
        </tr>
        <tr height="50" class="bg-gray">
          <td></td>
          <td class="text-right">
            <b>Total</b>
          </td>
          <td>{{  payment.Fee }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'email',
      'name',
      'company',
      'address',
      'tel',
      'payment',
      'receipt'
    ]),
    receiptDate() {
      var date = new Date(this.receipt.date).getDate()
      var month = new Date(this.receipt.date).getMonth()
      var year = new Date(this.receipt.date).getFullYear()
      var monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      return `${date} ${monthNames[month]} ${year}`
    }
  },
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: THSarabunNew-Bold_a;
  src: url("../assets/form/fonts/THSarabunNew-Bold_a.woff") format("woff");
}

@font-face {
  font-family: THSarabunNew_7;
  src: url("../assets/form/fonts/THSarabunNew_7.woff") format("woff");
}

@font-face {
  font-family: THSarabunNew_g;
  src: url("../assets/form/fonts/THSarabunNew_g.woff") format("woff");
}
.page-container {
  width: 210mm;
  height: 297mm;
  padding: 7.5mm;
}
.flex-1 {
  flex: 1;
}
.mlrs-title {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  margin-left: 1.5rem;
}
.payment-container {
  display: flex;
  flex-direction: column;
  text-align: left;
}
.sub-title {
  color: rgb(180, 180, 180);
}
tr {
  border: 1px solid black;
}
th {
  text-align: center;
}
.bg-gray {
  background-color: rgb(237, 237, 237);
}
// @media (max-width: 900px) {
//   .page-container {
//     zoom: 50%;
//     -moz-transform: scale(0.5);
//   }
// }
</style>
